import Api from "../../services/Api";

// Cache to store active promises
const inflightRequests = new Map();

function fetchSiteIdBySerial(serialNumber) {
  // 1. Check if there is already an active request for this serialNumber
  if (inflightRequests.has(serialNumber)) {
    return inflightRequests.get(serialNumber);
  }

  // 2. Make the API call
  const requestPromise = Api.post("/service/evse_controller/api/v1/query/ev_charger", {
    is: { serialNumber, isRetired: false },
  }).finally(() => {
    // 3. Cleanup: Remove the promise from cache when it settles (success or error)
    // This ensures subsequent calls will fetch fresh data.
    inflightRequests.delete(serialNumber);
  });

  // 4. Store the promise in the cache
  inflightRequests.set(serialNumber, requestPromise);

  return requestPromise;
}

export { fetchSiteIdBySerial };
